const initialResponse = {
  companyInfo: {
    id: "",
    name: "",
    street: "",
    zipCode: "",
    city: "",
    foundingYear: null,
    industry: "",
    turnoverClass: "",
    type: "",
    contactPerson: null
  },
  inquiryDetails: {
    id: "",
    status: "",
    bankOffers: [],
    details: {
      amount: null,
      loanKind: null,
      collaterals: [
        {
          kind: "",
          value: null,
          description: ""
        }
      ],
      machineAge: null,
      vehicleNew: null,
      companyRole: "",
      machineKind: null,
      productKind: null,
      purposeKind: [
        {
          kind: "",
          value: null
        }
      ],
      vehicleKind: null,
      vehicleYear: null,
      machinePrice: null,
      vehicleCount: null,
      vehicleModel: null,
      equitySupport: null,
      goodsSupplier: null,
      machineIsNew: null,
      banksToForward: null,
      energyEfficient: null,
      financialDemand: null,
      leasingTakeover: null,
      machineCategory: null,
      realEstateKind: null,
      financingSupport: null,
      goodsDescription: null,
      guaranteeSupport: null,
      otherDescription: null,
      considerSubsidies: null,
      equipmentSupplier: null,
      financingOwnIdea: "",
      innovativeCompany: null,
      machineIsOrdered: null,
      alreadyAtTheBank: null,
      leasingDescription: null,
      loanTermInMonths: null,
      machineDescription: null,
      productDescription: null,
      realEstateProject: null,
      structuringSupport: null,
      financingOwnFounds: null,
      goodsPurchasePrice: null,
      machineManufacturer: null,
      realEstateTaxation: null,
      realEstateZipCode: null,
      softwareDescription: null,
      vehicleManufacturer: null,
      equipmentDescription: null,
      favoredDecisionDate: "",
      liquidityDescription: null,
      machineDeliveryDate: null,
      machinePeriodOfUse: null,
      realEstateColdRent: null,
      softwareManufacturer: null,
      leasingResidualValue: null,
      leasingTermInMonths: null,
      machineOriginalPrice: null,
      realEstateUsageKind: null,
      realEstateUsageSize: null,
      softwarePeriodOfUse: null,
      vehicleYearlyMileage: null,
      negativeEquityCapital: null,
      equipmentPurchasePrice: null,
      loanFixedInterestRate: null,
      purposeKindDescription: null,
      realEstateKfwStandard: null,
      leasingAmortisationKind: null,
      realEstateBuildingSize: null,
      vehicleOtherDescription: null,
      realEstatePurchasePrice: null,
      realEstateScheduledDate: null,
      realEstateRentedOutArea: null,
      realEstateEligibleProject: null,
      goodsEstimatedDeliveryDate: null,
      realEstateConstructionDate: null,
      loanInterestPeriodInMonths: null,
      annualNetProfitOrLossClass: null,
      realEstateResidualPercentage: null,
      equipmentEstimatedDeliveryDate: null,
      liquidityEstimatedDeliveryDate: null,
      realEstateHeritableBuildingRight: null,
      loanInterestedInAlternativeFinancing: null,
      realEstateHeritableBuildingRightObligation: null
    },
    guaranteeBank: {
      state: ""
    },
    creator: {
      type: ""
    }
  },
  additionalInfo: {
    createdAt: "",
    inquiryCreator: {
      id: "",
      gender: undefined,
      email: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      position: null,
      type: ""
    },
    bankCode: "",
    bankName: ""
  }
};

export default initialResponse;
